import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0381bf80"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = {
  key: 3,
  class: "completion2-details-options"
}
const _hoisted_3 = {
  key: 0,
  class: "legenda"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legenda-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "legenda-item-door symbol" }),
  /*#__PURE__*/_createElementVNode("div", { class: "legenda-item-text" }, "Binnendeuren")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legenda-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "legenda-item-round symbol orange" }),
  /*#__PURE__*/_createElementVNode("div", { class: "legenda-item-text" }, "Punten t/m 1050mm")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legenda-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "legenda-item-round symbol grey" }),
  /*#__PURE__*/_createElementVNode("div", { class: "legenda-item-text" }, "Punten boven 1050mm")
], -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  style: {"margin-bottom":"0"}
}
const _hoisted_9 = {
  key: 1,
  style: {"margin-bottom":"0"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 3,
  style: {"margin":"12px 0 0 0","font-weight":"bold"}
}

import Completion2Menu from '@/components/completion2/Completion2Menu.vue'
import Completion2OptionsGrid from '@/components/completion2/Completion2OptionsGrid.vue'
import Completion2ElectricOptions from '@/components/completion2/Completion2ElectricOptions.vue'
import Completion2FooterButtons from '@/components/completion2/Completion2FooterButtons.vue'
import SubtotalWidget from '@/components/SubtotalWidget.vue'
import { useRouter } from 'vue-router'
import { computed, onMounted } from 'vue'
import { headerStore } from '@/stores/header'
import { authStore } from '@/stores/auth'
import { completionTwoStore } from '@/stores/completionTwo'
import { generalStore } from '@/stores/general'
import SubtotalMobileWidget from '@/components/SubtotalMobileWidget.vue'
import UnityWidget from '@/components/dashboard/UnityWidget.vue'
import { ls } from '@/ls'


export default /*#__PURE__*/_defineComponent({
  __name: 'Completion2',
  setup(__props) {

const router = useRouter()

const building = computed(() => ls.get('building'))
const isInternalTestAccount = computed(() => authStore().isInternalTestAccount)
const showOptions = computed(() => !['loading', 'test'].includes(completionTwoStore().phaseState) || isInternalTestAccount.value)

onMounted(() => {
  completionTwoStore().getPhaseState()
  completionTwoStore().getLevels()
})

const currentRoom = computed(() => {
  return completionTwoStore().rooms.find(r => r.id === completionTwoStore().current.room) || null
})

const currentGroup = computed(() => {
  return completionTwoStore().groups.find(g => g.id === completionTwoStore().current.group) || null
})

function openLayoutInNewTab (url:string) : void {
  window.open(url, '_blank')
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,4] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { title: "Afbouw 2 opties" }, {
            extra: _withCtx(() => [
              (_unref(building)?.unity_enabled && _unref(building)?.model_available)
                ? (_openBlock(), _createBlock(UnityWidget, {
                    key: 0,
                    style: { marginRight: '8px' }
                  }))
                : _createCommentVNode("", true),
              (_unref(generalStore)().desktop)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terug naar dashboard")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (['test', 'demo', 'closed'].includes(_unref(completionTwoStore)().phaseState) || _unref(authStore)().isDemoCustomer || _unref(completionTwoStore)().emptyLayout)
                ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          (_unref(completionTwoStore)().phaseState === 'test' && !_unref(isInternalTestAccount))
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 0,
                                type: "info",
                                message: "Er zijn voor deze fase (nog) geen opties beschikbaar.",
                                description: "Deze opties worden op een later moment zichtbaar.",
                                "show-icon": ""
                              }))
                            : _createCommentVNode("", true),
                          (_unref(completionTwoStore)().phaseState === 'demo' || _unref(authStore)().demoEnvironment)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 1,
                                type: "info",
                                message: "U bevindt zich in de demo omgeving.",
                                description: "U kunt (nog) geen definitieve bestelling plaatsen voor deze fase.",
                                "show-icon": ""
                              }))
                            : _createCommentVNode("", true),
                          (_unref(completionTwoStore)().phaseState === 'closed' && _unref(headerStore)().ordersReceived.completion && !_unref(authStore)().demoEnvironment)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 2,
                                type: "success",
                                message: "Bestelling succesvol ontvangen.",
                                "show-icon": ""
                              }, {
                                description: _withCtx(() => [
                                  _createTextVNode(" Wij hebben uw bestelling voor de afbouw opties succesvol ontvangen."),
                                  _hoisted_1,
                                  _createTextVNode(" Het is niet meer mogelijk om uw afbouw opties te wijzigen. Dit is om de voortgang van het bouwproces te continueren. ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_unref(completionTwoStore)().phaseState === 'closed' && !_unref(headerStore)().ordersReceived.completion && !_unref(authStore)().isDemoCustomer)
                            ? (_openBlock(), _createBlock(_component_a_alert, {
                                key: 3,
                                type: "error",
                                message: "Deze fase is gesloten maar wij hebben geen bestelling ontvangen!",
                                "show-icon": ""
                              }, {
                                description: _withCtx(() => [
                                  _createTextVNode(" Neem zo spoedig mogelijk contact op met Hofzicht Makelaars via telefoonnummer 0252 - 530119. ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(showOptions))
                ? (_openBlock(), _createBlock(Completion2Menu, { key: 1 }))
                : _createCommentVNode("", true),
              (_unref(showOptions))
                ? (_openBlock(), _createBlock(_component_a_divider, { key: 2 }))
                : _createCommentVNode("", true),
              (_unref(completionTwoStore)().currentElement && _unref(showOptions))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_unref(currentRoom) && _unref(currentGroup) && (_unref(currentRoom).layoutImages.electric || _unref(currentRoom).layoutImages.doors || _unref(currentRoom).layoutImages.withPositions))
                      ? (_openBlock(), _createBlock(_component_a_row, {
                          key: 0,
                          style: {"margin-bottom":"0"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              xs: {span: 24},
                              sm: {span: 24},
                              md: {span: 24},
                              lg: {span: 16}
                            }, {
                              default: _withCtx(() => [
                                (_unref(currentRoom).layoutImages.withPositions)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7))
                                  : _createCommentVNode("", true),
                                (_unref(currentGroup).number === 70 && _unref(currentRoom).layoutImages.electric)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "layout-image",
                                      style: _normalizeStyle({ backgroundImage: 'url(' + _unref(currentRoom).layoutImages.electric + ')' }),
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (openLayoutInNewTab(_unref(currentRoom).layoutImages.electric)))
                                    }, null, 4))
                                  : (_unref(currentGroup).number === 70)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 2,
                                        class: "layout-image",
                                        style: _normalizeStyle({ backgroundImage: 'url(' + _unref(currentRoom).layoutImages.withPositions + ')' }),
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (openLayoutInNewTab(_unref(currentRoom).layoutImages.withPositions)))
                                      }, null, 4))
                                    : (_unref(currentGroup).number !== 70 && _unref(currentRoom).layoutImages.doors)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 3,
                                          class: "layout-image",
                                          style: _normalizeStyle({ backgroundImage: 'url(' + _unref(currentRoom).layoutImages.doors + ')' }),
                                          onClick: _cache[3] || (_cache[3] = ($event: any) => (openLayoutInNewTab(_unref(currentRoom).layoutImages.doors)))
                                        }, null, 4))
                                      : (_unref(currentGroup).number !== 70 && _unref(currentRoom).layoutImages.other)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 4,
                                            class: "layout-image",
                                            style: _normalizeStyle({ backgroundImage: 'url(' + _unref(currentRoom).layoutImages.other + ')' }),
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (openLayoutInNewTab(_unref(currentRoom).layoutImages.other)))
                                          }, null, 4))
                                        : (_openBlock(), _createElementBlock("div", {
                                            key: 5,
                                            class: "layout-image",
                                            style: _normalizeStyle({ backgroundImage: 'url(' + _unref(currentRoom).layoutImages.withPositions + ')' }),
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (openLayoutInNewTab(_unref(currentRoom).layoutImages.withPositions)))
                                          }, null, 4))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_divider)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_a_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            (_unref(currentRoom))
                              ? (_openBlock(), _createElementBlock("h2", _hoisted_8, _toDisplayString(_unref(currentRoom).level) + "." + _toDisplayString(_unref(currentRoom).position) + " - " + _toDisplayString(_unref(currentRoom).name), 1))
                              : _createCommentVNode("", true),
                            (_unref(completionTwoStore)().currentElement)
                              ? (_openBlock(), _createElementBlock("h3", _hoisted_9, [
                                  _createTextVNode(_toDisplayString(_unref(completionTwoStore)().currentElement.name_sales), 1),
                                  (_unref(currentGroup) && [30, 70].includes(_unref(currentGroup).number))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, " op positie " + _toDisplayString(_unref(completionTwoStore)().currentElement.position), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(completionTwoStore)().currentElement)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  innerHTML: _unref(completionTwoStore)().currentElement.text_sales
                                }, null, 8, _hoisted_11))
                              : _createCommentVNode("", true),
                            (_unref(currentGroup) && [70].includes(_unref(currentGroup).number) && _unref(completionTwoStore)().currentElement && _unref(completionTwoStore)().currentElement.mirrored)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Let op! Dit elektrapunt wordt gevuld van rechts naar links!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_unref(completionTwoStore)().currentElement && _unref(completionTwoStore)().currentElement.selectorType === 'default')
                      ? (_openBlock(), _createBlock(Completion2OptionsGrid, { key: 1 }))
                      : (_unref(completionTwoStore)().currentElement && _unref(completionTwoStore)().currentElement.selectorType === 'electric')
                        ? (_openBlock(), _createBlock(Completion2ElectricOptions, { key: 2 }))
                        : _createCommentVNode("", true),
                    _createVNode(Completion2FooterButtons)
                  ]))
                : (_unref(completionTwoStore)().emptyLayout)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 4,
                      type: "info",
                      message: "Geen opties voor deze ruimte.",
                      description: "Het is in de geselecteerde ruimte niet mogelijk om opties te kiezen. Mogelijk omdat u voor een CASCO indeling heeft gekozen. Kies een andere ruimte om verder te gaan.",
                      "show-icon": ""
                    }))
                  : (_unref(showOptions))
                    ? (_openBlock(), _createBlock(_component_a_skeleton, {
                        key: 5,
                        active: ""
                      }))
                    : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 6
          }, {
            default: _withCtx(() => [
              _createVNode(SubtotalWidget)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(SubtotalMobileWidget, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})